import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Legal from "@/pages/Legal";
import Privacy from "@/pages/Privacy";
import LearnHub from "@/pages/LearnHub";
import Lesson from "@/pages/Lesson";
import About from "@/pages/About";
import QuantLab from "@/pages/QuantLab";
import ResearchPaper from "@/pages/ResearchPaper";
import IndicatorDocs from "@/pages/IndicatorDocs";
import TerminalHub from "@/pages/TerminalHub";
import Compare from "@/pages/Compare";
import ExchangeData from "@/pages/ExchangeData";
import FlowCells from "@/pages/FlowCells";
import FontSpecimen from "@/pages/FontSpecimen";
import Referral from "@/pages/Referral";
import OrderFlow from "@/pages/OrderFlow";
import Guide from "@/pages/Guide";
import BgLab from "@/pages/BgLab";
import HeroLab from "@/pages/HeroLab";
import FooterLab from "@/pages/FooterLab";
import ModulePage from "@/pages/ModulePage";
import AnalyticsAdmin from "@/pages/AnalyticsAdmin";
import MailAdmin from "@/pages/MailAdmin";
import JoinFunnel from "@/pages/JoinFunnel";
import { usePageTracking } from "@/hooks/usePageTracking";
import { captureRef } from "@/lib/account";

captureRef();

function TrackedRoutes() {
  usePageTracking();
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/join" element={<JoinFunnel />} />
      <Route path="/start" element={<JoinFunnel />} />
      <Route path="/legal" element={<Legal />} />
      <Route path="/terms" element={<Legal />} />
      <Route path="/risk" element={<Legal />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/learn" element={<LearnHub />} />
      <Route path="/learn/guide/:slug" element={<Guide />} />
      <Route path="/learn/:slug" element={<Lesson />} />
      <Route path="/about" element={<About />} />
      <Route path="/research" element={<QuantLab />} />
      <Route path="/research/:slug" element={<ResearchPaper />} />
      <Route path="/tools/tradrquant-pro-indicator" element={<IndicatorDocs />} />
      <Route path="/terminal" element={<TerminalHub />} />
      <Route path="/compare" element={<Compare />} />
      <Route path="/data/hyperliquid-binance-okx-order-flow" element={<ExchangeData />} />
      <Route path="/flow-cells-whale-rotation-map" element={<FlowCells />} />
      <Route path="/fonts" element={<FontSpecimen />} />
      <Route path="/bg-lab" element={<BgLab />} />
      <Route path="/hero-lab" element={<HeroLab />} />
      <Route path="/footer-lab" element={<FooterLab />} />
      <Route path="/referral" element={<Referral />} />
      <Route path="/order-flow" element={<OrderFlow />} />
      <Route path="/terminal/:slug" element={<ModulePage />} />
      <Route path="/admin/analytics" element={<AnalyticsAdmin />} />
      <Route path="/admin/mail" element={<MailAdmin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <TrackedRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
